import React from 'react';
import {useStyles} from './helper';

const Title = ({label}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <span className={classes.helper}>{label}</span>
        </div>
    )
}

export default Title;